import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import Ticket from 'src/interfaces/api/Ticket';
import ClosedResponsabilitySelect from './components/ClosedResponsabilitySelect';
import { createUseStyles } from 'src/theming';
import { Controller, useForm } from 'react-hook-form';

interface CloseTicketOptions {
  ticketClosedReasonId: number;
  comment: string;
}

interface Props {
  ticket: Ticket;
  open: boolean;
  onClose: () => void;
  onCloseTicket: (id: string, ticketClosedReasonId: number, comment?: string) => Promise<Ticket>;
}

const useStyles = createUseStyles({
  formField: {
    marginTop: '15px !important',
  },
  error: {
    color: '#f44336',
  },
});

const TicketCloseModal: FC<Props> = ({ ticket, open, onCloseTicket, onClose }) => {
  const [formError, setFormError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit, reset } = useForm<CloseTicketOptions>();

  const classes = useStyles();

  const onSubmit = async (closeTicketOptions: CloseTicketOptions) => {
    const { ticketClosedReasonId, comment } = closeTicketOptions;

    try {
      setLoading(true);

      await onCloseTicket(ticket.id, ticketClosedReasonId, comment);

      setLoading(false);
      setFormError(undefined);
      onClose();
    } catch (e) {
      setLoading(false);
      setFormError(e.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Clôture du ticket</DialogTitle>

      <DialogContent>
        <Controller
          name='ticketClosedReasonId'
          control={control}
          rules={{ required: { value: true, message: 'Le champ est requis' } }}
          render={({ field, fieldState: { error } }) => (
            <ClosedResponsabilitySelect className={classes.formField} formError={error} {...field} />
          )}
        />

        <Controller
          name='comment'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              error={!!error}
              className={classes.formField}
              InputLabelProps={{ shrink: true }}
              label='Commentaire'
              helperText={error && error.message}
              multiline
              rows={4}
              variant='outlined'
              {...field}
              fullWidth
            />
          )}
        />

        {formError && <p className={classes.error}>{formError}</p>}
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' onClick={handleSubmit(onSubmit)} color='primary'>
          {loading && <CircularProgress color='primary' size={15} />} Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketCloseModal;
